import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function NewsDetail() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/news/${id}`).then((r) => setArticle(r.data)).catch(() => setError("Article not found."));
  }, [id]);

  if (error) return <div className="max-w-3xl mx-auto py-24 px-6 text-center text-[color:var(--azsam-ink-soft)]">{error}</div>;
  if (!article) return <div className="max-w-3xl mx-auto py-24 px-6 text-center text-[color:var(--azsam-ink-soft)]" data-testid="news-detail-loading">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 lg:px-8 py-20" data-testid="news-detail">
      <Link to="/news" className="inline-flex items-center gap-2 text-sm text-[color:var(--azsam-ink-soft)] hover:text-[color:var(--azsam-clay)]" data-testid="news-back">
        <ArrowLeft size={16} /> All updates
      </Link>
      <div className="overline mt-8">{formatDate(article.published)} · {article.author}</div>
      <h1 className="mt-4 font-heading text-4xl sm:text-5xl leading-[1.1]">{article.title}</h1>
      {article.image_url && (
        <img src={article.image_url} alt="" className="mt-10 w-full h-[380px] object-cover rounded-2xl" />
      )}
      <p className="mt-10 text-lg text-[color:var(--azsam-ink-soft)] leading-relaxed font-medium">{article.excerpt}</p>
      <div className="mt-8 text-[color:var(--azsam-ink)] leading-relaxed whitespace-pre-wrap" data-testid="news-body">
        {renderBodyWithLinks(article.body)}
      </div>
    </article>
  );
}

function renderBodyWithLinks(text) {
  if (!text) return null;
  const urlRegex = /(https?:\/\/[^\s)<>]+[^\s)<>.,;:!?'"])/g;
  const parts = text.split(urlRegex);
  return parts.map((part, i) => {
    if (/^https?:\/\//.test(part)) {
      return (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noreferrer"
          className="text-[color:var(--azsam-clay)] underline break-all hover:text-[color:var(--azsam-clay-hover)]"
        >
          {part}
        </a>
      );
    }
    return <span key={i}>{part}</span>;
  });
}

function formatDate(iso) {
  try { return new Date(iso + "T00:00:00").toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }); }
  catch { return iso; }
}
